var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import UserPropDialog from '../CreateDialogue/UserPropDialog';
import EditUserPropDialog from '../EditDialogue/EditUserPropDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');


export default function UserPropsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [userProps, setUserProps] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const handleDialogCallback = (childData) => {
        fetch("/api/UserPropType", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "user_prop_type": [{
                    "Name": childData.Name,
                    "IsDropdown": childData.IsDropdown,
                    "Validation": childData.Validation,
                    "DefaultFormat": childData.DefaultFormat,
                    "IsActive": childData.IsActive
                }],
                "user_prop_item": childData.PropList
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const EditHandleDialogCallback = (childData) => {
        fetch("api/UserPropType", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "user_prop_type": {
                    "ID": childData.ID,
                    "Name": childData.Name,
                    "IsDropdown": childData.IsDropdown,
                    "Validation": childData.Validation,
                    "DefaultFormat": childData.DefaultFormat,
                    "IsActive": childData.IsActive
                },
                "user_prop_item": childData.PropList
            })
        })
        setRefresh(true);
    };

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            fetch('api/UserPropType', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setUserProps(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
    })
    
	const columns = [];
	if (permissions.CreateUserProperties == 1) {
		const adminActions = {
			name: "Admin Actions",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					return (
						<div>
							<EditUserPropDialog EditHandleDialogCallback={EditHandleDialogCallback} data={userProps[dataIndex]} />
						</div>
					);
				}

			}
		};
		columns.push(adminActions);
	}

	const columns1 = [
		{
			name: "Name",
			label: "Name",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
            name: "IsDropdown",
            label: "Type",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{userProps[dataIndex].IsDropdown==0 ? "Text field" : "Dropdown"}
                        </div>
                    );
                }
            }
        },
		{
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	{(userProps[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );
                }
            }
		}	
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('UserProprowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('UserProprowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    columns.push(...columns1);

  const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
      selectableRows: 'none',
      rowsPerPage: initialRowsPerPage,
      rowsPerPageOptions: [10, 20, 50, 100],
      textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
       onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'UserProps.xlsx', columnIndexToRemove:0});
			return false;
		},
        customToolbar: () => permissions.CreateUserProperties===1 && !isLoading ?  (<UserPropDialog handleDialogCallback={handleDialogCallback} />):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="UserPropsTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft User Properties
                        </Typography>
                    }
                    data={isLoading ? [] :userProps}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
}  